import { aspirationsService } from './aspirationsService';
import { goalsService } from './goalsService';
import { listsService } from './listsService';
import { calendarService } from './calendarService';
import { onboardingAspiration, onboardingGoals } from '../data/onboarding/godmodeAspiration';
import { useAspirationsStore } from '../store/aspirationsStore';
import { useGoalsStore } from '../store/goalsStore';
import { useListsStore } from '../store/listsStore';

const ASPIRATIONS_KEY = 'godmode_aspirations';

export const onboardingService = {
  async seedOnboardingData(): Promise<void> {
    // Skip if user already has aspirations (pre-signup anonymous usage)
    const existing = localStorage.getItem(ASPIRATIONS_KEY);
    if (existing) {
      try {
        const parsed = JSON.parse(existing);
        if (Array.isArray(parsed) && parsed.length > 0) {
          console.log('Onboarding skipped: user already has aspirations');
          return;
        }
      } catch {
        // Invalid data, proceed with seeding
      }
    }

    console.log('Seeding onboarding aspiration...');

    // Create the aspiration
    const aspiration = await aspirationsService.createAspiration({
      ...onboardingAspiration,
      status: 'not_started',
      progress: 0,
      linkedGoals: [],
    });

    // Create goals and their lists, track the first list for scheduling
    let firstListId: string | null = null;

    for (const goalData of onboardingGoals) {
      const goal = await goalsService.createGoal({
        ...goalData.goal,
        aspirationId: aspiration.id,
      });

      for (const listData of goalData.lists) {
        const list = await listsService.createList({
          ...listData,
          goalId: goal.id,
        });
        if (!firstListId) {
          firstListId = list.id;
        }
      }
    }

    // Schedule the first onboarding list with a daily reminder
    if (firstListId) {
      const tomorrow = new Date();
      tomorrow.setDate(tomorrow.getDate() + 1);
      tomorrow.setHours(9, 0, 0, 0);

      calendarService.createSchedule({
        listId: firstListId,
        type: 'daily',
        recurringPattern: {
          dailyInterval: 1,
          startDate: tomorrow,
          time: '09:00',
        },
        title: 'Get Into GodMode',
        description: 'Work through your onboarding checklist to master GodMode.',
        isActive: true,
        notifications: [
          {
            id: `notif-onboarding-${Date.now()}`,
            type: 'push',
            minutesBefore: 0,
            message: 'Time to work on your GodMode setup!',
            isEnabled: true,
          },
        ],
      });
    }

    // Refresh stores so UI updates without page reload
    useAspirationsStore.getState().initializeAspirations();
    useGoalsStore.getState().initializeGoals();
    useListsStore.getState().initializeLists();

    console.log('Onboarding aspiration seeded successfully');
  },
};
